import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { useDebugRerenders } from '@wix/da-hooks/pkg/useDebugRerenders';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import BaseTorpedo from '../BaseTorpedo';
function getMeasuredContainer(containerFromProps, measuredContainer) {
    var _measuredContainer_width;
    return {
        width: Number((_measuredContainer_width = measuredContainer === null || measuredContainer === void 0 ? void 0 : measuredContainer.width) !== null && _measuredContainer_width !== void 0 ? _measuredContainer_width : containerFromProps.width)
    };
}
const MeasuredTorpedo = (props)=>{
    const { ref, dimensions } = useMeasureElementCookie(props.cookieType, {
        cookieDim: 'width',
        defaultSize: props.defaultSize
    });
    useDebugRerenders('MeasuredTorpedo', _object_spread_props(_object_spread({}, props), {
        dimensions
    }));
    const container = getMeasuredContainer(props.container, dimensions);
    const refactor_torpedo_layout = useFlag('refactor_torpedo_layout');
    var _props_layoutV2;
    const layoutV2 = (_props_layoutV2 = props.layoutV2) !== null && _props_layoutV2 !== void 0 ? _props_layoutV2 : refactor_torpedo_layout;
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref
    }, /*#__PURE__*/ React.createElement(BaseTorpedo, _object_spread_props(_object_spread({}, props), {
        container: container,
        layoutV2: layoutV2
    })));
};
MeasuredTorpedo.displayName = 'MeasuredTorpedo';
export default MeasuredTorpedo;

//# sourceMappingURL=MeasuredTorpedo.js.map